import { useState } from "react";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { AppRouter, createAppRouter } from "@/router";
import { Toaster } from "@/components/ui/sonner";
import { ErrorBoundary } from "@/components/ErrorBoundary";

export function App(): React.ReactElement {
  // Bind a single QueryClient + Router for the lifetime of the app.
  // useState init runs once even under StrictMode double-mount.
  const [queryClient] = useState(
    () =>
      new QueryClient({
        defaultOptions: {
          queries: {
            retry: 1,
            staleTime: 30_000,
            refetchOnWindowFocus: false,
          },
        },
      }),
  );
  const [router] = useState(() => createAppRouter(queryClient));

  // ErrorBoundary wraps the router so any render-time crash falls back to a
  // calm UI with the server-side `request_id`. Toaster lives OUTSIDE the
  // boundary so the "copy request_id" toast still renders even when the
  // boundary itself is on screen. Security task 18 §6.1.
  return (
    <QueryClientProvider client={queryClient}>
      <ErrorBoundary>
        <AppRouter router={router} />
      </ErrorBoundary>
      <Toaster position="top-center" />
    </QueryClientProvider>
  );
}
